import React from "react";

import { Button } from "@material-ui/core";
import { showFile, ShowFile } from "services/fake/fakeDocumentManager";
import { SaveAlt } from "@material-ui/icons";

import "./DownloadButton.scss";

export const DownloadButton = ({ file, text, onClick, className }: any) => (
  <Button
    className={"download-button" + (className ? " " + className : "")}
    onClick={() => {
      showFile(ShowFile.Download, file);
      onClick();
    }}
  >
    <SaveAlt />
    <label>{text}</label>
  </Button>
);
